import { isAndroidBrowser } from '../isAndroidBrowser';

const isAndroidAcceptParams = {
  accept: {},
  extraAccept: 'image/*;capture=camera',
};

export function acceptMediaAndroid(
  navigator: Navigator | undefined,
): Record<string, never> | typeof isAndroidAcceptParams {
  if (isAndroidBrowser(navigator)) {
    return isAndroidAcceptParams;
  }
  return {};
}
